import { InferType } from 'yup';

import { basicAddress } from '../../schemas';

type AddressType = InferType<typeof basicAddress>;

export function addressEquals(a: AddressType, b: AddressType) {
  return (
    // loose equality intentional: null == undefined so "not set" matches "not set"
    // eslint-disable-next-line eqeqeq
    a.pOIId == b.pOIId && a.streetID == b.streetID && a.houseNo == b.houseNo
  );
}
